import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { CRMInfoSection } from "../CRMInfoSection";
import { ReactComponent as UserIcon } from "./assets/user.svg";

export const CRMConnectionTipsSection: React.FC = () => {
  const { t } = useTranslations();

  return (
    <CRMInfoSection
      title={t({
        id: "client-support-page.tools-and-tips",
        defaultMessage: "Tools & Tips",
      })}
      subtitle={t({
        id: "client-support-page.everything-you-need-to-know",
        defaultMessage: "Everything you need to know:",
      })}
      items={[
        {
          icon: <UserIcon />,
          title: t({
            id: "client-support-page.connection-status",
            defaultMessage: "Connection Status",
          }),
          tips: [
            t({
              id: "client-support-page.connection-status-connected",
              defaultMessage: `If account status is "Connected", it means it's working perfectly fine`,
            }),
            t({
              id: "client-support-page.connection-status-disconnected",
              defaultMessage: `If account status is "Disconnected", it needs to be reconnected to proceed CRM work`,
            }),
          ],
        },
      ]}
    />
  );
};
